export const sortNumber = (s1: any, s2: any): number => s2 - s1
